import * as React from 'react';

import { Row as AntdRow, Col } from 'antd';
import { Row, Space, Text } from 'farmhub-ui-core';
import styled from 'styled-components';

import { useAppSelector } from 'app';
import { CategorySelected, CheckFilterItemSkeleton } from 'components';
import { selectCategory } from 'slice';
import { getDummyArray } from 'utils/function';

import { MobileWrapper, SectionDataMobile } from './styles';

interface SelectCategoriesStepProps {
  data: any;
  isLoadingCategory: boolean;
  handleClickCategories: (e: string) => void;
  handleSelectAllOrDeleteCategories: () => void;
}

const SelectCategoriesStepMobile = ({
  data,
  isLoadingCategory,
  handleClickCategories,
  handleSelectAllOrDeleteCategories,
}: SelectCategoriesStepProps): JSX.Element => {
  const categoryList = useAppSelector(selectCategory);

  return (
    <MobileWrapper>
      <Row justifyContent="space-between">
        <Text color="dark" weight="bold">
          Lựa chọn danh mục ({data.categoryIDs.length})
        </Text>
        <DeleteText onClick={handleSelectAllOrDeleteCategories}>
          {data.categoryIDs.length > 0 ? 'Xóa tất cả' : 'Chọn tất cả'}
        </DeleteText>
      </Row>
      <Space height={12} />
      <SectionDataMobile>
        <AntdRow gutter={[12, 12]}>
          {isLoadingCategory
            ? getDummyArray(12).map(item => (
                <Col span={8}>
                  <CheckFilterItemSkeleton key={item.key} />
                </Col>
              ))
            : categoryList.list
                .filter(item => !item.isDefault)
                .map((item: any, index: number) => (
                  <Col span={8} onClick={() => handleClickCategories(item.id)}>
                    <CategorySelected
                      key={item.id}
                      image={item.avatar}
                      selected={data.categoryIDs.includes(item.id)}
                      title={item.name}
                    />
                  </Col>
                ))}
        </AntdRow>
      </SectionDataMobile>
    </MobileWrapper>
  );
};

export default SelectCategoriesStepMobile;

const DeleteText = styled.span`
  font-weight: ${p => p.theme.font.weight.regular};
  font-size: ${p => p.theme.font.size.xs};
  text-decoration-line: underline;
  color: #ff6347;
  cursor: pointer;

  text-underline-offset: 3px;
`;
